import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateNotificationStatus: (
    fetchContext: FetchContext,
    notificationId: number,
    isActive: boolean,
    accessToken?: string,
) => Promise<void> = (fetchContext, notificationId, isActive, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/notifications/${notificationId}/status`,
  {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(isActive),
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update notification status'));
